// Keyed by platformAgentName: `amigo` on FoodAmigos, `assistant` on a partner's dashboard.
export default {
  label: {
    amigo: 'Preguntar a Amigo',
    assistant: 'Asistente',
  },
  // The button's name while it shows a count of answers the person hasn't seen (the count itself is hidden from
  // screen readers).
  label_unread: {
    amigo_one: 'Preguntar a Amigo, nuevos: {{count}}',
    amigo_other: 'Preguntar a Amigo, nuevos: {{count}}',
    assistant_one: 'Asistente, nuevos: {{count}}',
    assistant_other: 'Asistente, nuevos: {{count}}',
  },
  unavailable_label: {
    amigo: 'Amigo no disponible',
    assistant: 'Asistente no disponible',
  },
  unavailable_text: {
    amigo: 'Amigo no está disponible en este momento.',
    assistant: 'El asistente no está disponible en este momento.',
  },
};
